<template>
	<div class="chat-container w-100 position-relative bg-light-page bg-white" style="min-height: 100vh;margin-bottom: -60px">
		<div class="my-5" v-if="is_load">
			<loader />
		</div>
		<template v-else>
      <div class="m-4" v-if="error.reservation != ''">
        <ErrorMessage :message="error.reservation" />
      </div>
      <template v-else>
  			<cartHeader :step="2" backto="concierge"></cartHeader>
        <div class="height-100px bg-light-page"></div>
  			<template>
          <div class="bg-light-page" id="top_id" style="height: 20px"></div>
          <div class="pt-4 pb-3 px-3 bg-light-page">
            <div class="rounded-6 bg-white box-shadow-bold mb-4" @click="show_detail = !show_detail">
              <div class="px-3">
                <div class="row no-gutters py-2">
                  <div class="col-12 align-self-center" @click="show_detail = !show_detail">
                    <img :src="getMerchant().image_url" class="img-hotel mr-3 rounded-6 object-fit d-inline-block align-middle">
                    <div class="d-inline-block align-middle concierge-menu-top-wrapper">
                      <div class="mb-1">
                        <p class="mb-0 body-2-2 font-bold text-truncate">{{getMerchant().name}}</p>
                        <p class="mb-0 body-3-3 font-bold">{{reservation.room_type.name}}</p>
                        <p class="mb-0 body-3-3 font-semibold" v-if="reservation.room != null">{{reservation.room.name}}</p>
                        <p class="mb-0 body-3-3 font-weight-bold text-green mr-2 pr-2 border-right">{{$t('hotel.concierge.folio')}} #{{reservation.folio_number}}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="py-2 border-top px-3 cursor-pointer">
                <div class="row no-gutters">
                  <div class="col-10 align-self-center">
                    <p class="mb-0 body-2-2 font-bold">{{$t('hotel.concierge.unpaid-bill')}} : <span class="font-bold text-danger">{{formatCurrency(balance)}}</span></p>
                  </div>
                  <div class="col-2 align-self-center text-right">
                    <i :class="{'simple-icon-arrow-up' : show_detail, 'simple-icon-arrow-down' : !show_detail}" class="text-danger text-16"></i>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="show_detail" class="rounded-6 bg-white box-shadow-bold mb-4">
              <div class="px-3 pt-2">
                <div class="row no-gutters justify-content-start border-light-bottom py-2" v-for="(bill,index) in bills" v-if="!bill.is_minus" :key="index" >
                  <div class="col-7">
                    <p class="mb-0 body-3-3 font-bold">{{bill.description}}</p>
                    <p class="mb-0 body-3-3">{{bill.remark}}</p>
                  </div>
                  <div class="col-5 text-right">
                    <p class="mb-0 body-3-3 font-bold">{{formatCurrency(bill.amount)}}</p>
                    <p class="mb-0 body-3-3">{{formatDate(bill.dates)}}</p>
                  </div>
                </div>
                 <!-- TOTAL BILL -->
                <div class="row no-gutters pt-3 pb-1">
                  <div class="col-7">
                    <p class="mb-0 body-2-2 font-bold">{{$t('hotel.concierge.total')}}</p>
                  </div>
                  <div class="col-5 text-right">
                    <p class="mb-0 body-2-2 font-bold">{{formatCurrency(bill.total)}}</p>
                  </div>
                </div>

                <!-- PAYMENT  -->
                <div class="row no-gutters py-1" @click="detail_payment = !detail_payment" v-if="!detail_payment">
                  <div class="col-7">
                    <div class="w-100 cursor-pointer">
                      <p class="mb-0 d-inline-block align-middle body-2-2 font-bold text-green">{{$t('hotel.concierge.paid')}}</p>
                      <p class="mb-0 d-inline-block align-middle body-3-3">({{$t('hotel.concierge.tap-to-see-detail-payment')}})</p>
                    </div>
                  </div>
                  <div class="col-5 text-right">
                    <p class="mb-0 body-2-2 font-bold text-green">{{formatCurrency(payment.total)}}</p>
                  </div>
                </div>
                <div v-else  @click="detail_payment = !detail_payment" class="rounded-6 bg-white border-green my-2">
                  <div class="p-2">
                    <p class="mb-1 pb-1 border-bottom body-2-2 font-bold text-green">{{$t('hotel.concierge.paid')}}</p>
                    <div 
                    class="row no-gutters justify-content-start border-light-bottom py-2"
                    :class="{'border-light-bottom' : payment_index+1 != payment.list.length, 'border-bottom': payment_index+1 == payment.list.length}" 
                    v-for="(payment_item,payment_index) in payment.list">
                      <div class="col-7">
                        <p class="mb-0 body-3-3 font-semibold">{{payment_item.description}}</p>
                        <p class="mb-0 body-3-3">{{formatDate(payment_item.dates)}}</p>
                      </div>
                      <div class="col-5 text-right">
                        <p class="mb-0 body-3-3 font-semibold">{{formatCurrency(payment_item.amount)}}</p>
                      </div>
                    </div>
                    <div class="row no-gutters justify-content-start pt-2">
                      <div class="col-7">
                        <p class="mb-0 body-2-2 font-bold text-green">{{$t('hotel.concierge.total-paid')}}</p>
                      </div>
                      <div class="col-5 text-right">
                        <p class="mb-0 body-2-2 font-bold text-green">{{formatCurrency(payment.total)}}</p>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- BALANCE -->
                <div class="row no-gutters pb-3 pt-1">
                  <div class="col-7">
                    <p class="mb-0 body-2-2 font-bold text-danger">{{$t('hotel.concierge.balance')}}</p>
                  </div>
                  <div class="col-5 text-right">
                    <p class="mb-0 body-2-2 font-bold text-danger">{{formatCurrency(balance)}}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Payment Methods -->
          <div class="container bg-light-page px-4 py-2"> 
            <div v-if="pm_loader" class="w-100 my-5 text-center">
              <loader />
            </div>
            <template v-else>
              <div class="p-3 d-block" v-if="error.payment_list != ''">
                <div class="p-3 border radius-0" style="background-color: rgb(255, 243, 243);border-color: #feb8b8 !important;">
                  <div class="row grid-slim-row">
                    <div class="col-12 text-center">
                      <p class="mb-0 body-3-1">{{error.payment_list}}</p>
                    </div>
                  </div>
                </div>
              </div>
              <template v-else>
                <p class="mb-2 body-2-2 text-16 font-bold">{{$t('hotel.payment-method.choose-payment-method')}}</p>
                <p class="mb-4 body-2-2 text-14 font-regular" v-html="getMerchant().payment_description"></p>
                <div 
                  class="mb-3 px-3 py-2 rounded-6 delay cursor-pointer box-shadow-bold overflow-hidden" 
                  :class="{'border-green': pm.is_selected,'bg-white': !pm.is_selected,'bg-light-page h-auto': pm.is_selected}" 
                  v-for="(pm,index) in payment_methods" 
                  @click="togglePayment(index)" 
                  style="height: 70px;background-color: #fff">
                  <div class="row no-gutters pt-1">
                    <div class="col-1">
                      <div class="w-16px rounded-100 border-2-green" style="margin-top: 12px;">
                        <div class="w-8px rounded-100 position-relative mx-auto mt-2px" :class="{'bg-green': pm.is_selected}"></div>
                      </div>
                    </div>
                    <div class="col-8">
                      <p class="mb-0 ml-2 body-2-2 font-bold text-16" :class="{'pt-2':pm.is_selected}">{{pm.data.name}}</p>
                      <p class="mb-0 pb-2 ml-2 body-2-2 text-12 text-truncate" v-if="!pm.is_selected" v-html="pm.data.description"></p>
                    </div>
                    <div class="col-3 text-right">
                      <img :src="pm.data.image_url" height="28">
                    </div> 
                    <div class="col-12" v-if="pm.is_selected">
                      <p class="mb-0 ml-2 body-2-2 pb-2 text-12 pt-2" v-html="pm.data.description"></p>
                    </div>
                  </div>
                </div>
                <!-- ERROR MESSAGE -->
                <div class="p-3 d-block" v-if="error.payment != ''">
                  <div class="p-3 border radius-0" style="background-color: rgb(255, 243, 243);border-color: #feb8b8 !important;">
                    <div class="row grid-slim-row">
                      <div class="col-12 text-center">
                        <p class="mb-0 body-3-1">{{error.payment}}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </template>
          </div>
          <!-- BUTTON PAYMENT -->
          <div class="container px-4 bg-light-page box-shadow-footer">
            <div class="row no-gutters pt-2">
              <div class="col-6 pt-1">
                <p class="mb-2 body-2-2 text-14 font-semibold">{{$t("hotel.concierge.unpaid-bill")}} : </p>
                <p v-if="payment_surcharge > 0" class="mb-0 body-2-2 text-14 font-semibold">{{$t('hotel.payment-surcharge')}} : </p>
              </div>
              <div class="col-6 pt-1 text-right">
                <p class="mb-0 body-2-2 text-16 font-bold text-danger">{{formatCurrency(balance)}}</p>
                <p v-if="payment_surcharge > 0" class="mb-0 body-2-2 text-16 font-semibold">{{formatCurrency(payment_surcharge)}}</p>
              </div>
              <div class="col-12">
                <div class="row no-gutters border-top mt-2 pt-2">
                  <div class="col-6">
                    <p class="mb-0 body-2-2 text-14 font-bold">{{$t('hotel.concierge.total-payment')}} : </p>
                  </div>
                  <div class="col-6 text-right">
                    <p class="mb-0 body-2-2 text-16 font-extrabold text-green">{{formatCurrency(total_bill)}}</p>
                  </div>
                </div>
              </div>
            </div>
            <button type="button" :disabled="!is_payment_valid || push_loading.payment" class="button-secondary w-100 my-3" :class="{'button-disabled':!is_payment_valid || push_loading.payment}" @click="submitPaymentBill">
              <pulse-loader :loading="push_loading.payment" color="#fff" v-if="push_loading.payment"></pulse-loader>
              <p class="mb-0" v-else>{{$t('hotel.action.payment')}}</p>
            </button>
          </div>
        </template>
      </template>
		</template>
    <form :action="dkpayload.URL" method="post" id="dkpayform2018" name="dkpayform2018" ref="FormDKload">
      <input name="MALLID" type="hidden" v-model="dkpayload.MALLID" >
      <input name="BASKET" type="hidden" v-model="dkpayload.BASKET" >
      <input name="CHAINMERCHANT" type="hidden" v-model="dkpayload.CHAINMERCHANT" >
      <input name="AMOUNT" type="hidden" v-model="dkpayload.AMOUNT" >
      <input name="PURCHASEAMOUNT" type="hidden" v-model="dkpayload.PURCHASEAMOUNT" >
      <input name="TRANSIDMERCHANT" type="hidden" v-model="dkpayload.TRANSIDMERCHANT" >
      <input name="WORDS" type="hidden" v-model="dkpayload.WORDS" >
      <input name="CURRENCY" type="hidden" v-model="dkpayload.CURRENCY" >
      <input name="PURCHASECURRENCY" type="hidden" v-model="dkpayload.PURCHASECURRENCY" >
      <input name="COUNTRY" type="hidden" v-model="dkpayload.COUNTRY" >
      <input name="SESSIONID" type="hidden" v-model="dkpayload.SESSIONID" >
      <input name="PAYMENTCHANNEL" type="hidden" v-model="dkpayload.PAYMENTCHANNEL" >
      <input name="REQUESTDATETIME" type="hidden" v-model="dkpayload.REQUESTDATETIME" >
      <input name="NAME" type="hidden" v-model="dkpayload.NAME" >
      <input name="EMAIL" type="hidden" v-model="dkpayload.EMAIL" >
      <input name="ADDRESS" type="hidden" v-model="dkpayload.ADDRESS" >
      <input name="MOBILEPHONE" type="hidden" v-model="dkpayload.MOBILEPHONE" >
    </form>
	</div>
</template>
<script>
	import {mapGetters,mapMutations} from 'vuex';
	import {post,get} from '@/services/index.js';
  import config from '@/config/index.js';
	import moment from 'moment';
	import cartHeader from '@/components/hotel/cartHeader';
	import {formatCurrency,postLog,paymentMethodConverter,formatDate} from '@/utils/index.js';
  import Form from '../../../base'

	export default{
		components:{
			cartHeader
		},
    metaInfo(){
      return {
        title: 'Payment Method',
        titleTemplate: this.getMetaTitleTemplate()
      }
    },
		data(){
			return{
				is_load: true,
        pm_loader: true,
				list: [],
				push_loading: {
					payment: false
				},
        show_detail: false,
				payment_methods: [],
        payment_methods_index: '',
        payment_details: '',
				date:{
					in: moment().add(3,'d').format('YYYY-MM-DD'),
					out: moment().add(5,'d').format('YYYY-MM-DD')
				},
				error:{
          reservation: '',
          payment: '',
          payment_list: ''
        },
        dkpayload : new Form({
          MALLID : '',
          BASKET : '',
          CHAINMERCHANT : '',
          AMOUNT : '',
          PURCHASEAMOUNT : '',
          TRANSIDMERCHANT : '',
          WORDS : '',
          REQUESTDATETIME : '',
          CURRENCY : '',
          PURCHASECURRENCY : '',
          SESSIONID : '',
          PAYMENTCHANNEL: '',
          NAME : '',
          EMAIL : '',
          ADDRESS : '',
          COUNTRY : '',
          URL : '',
        }),
        // new data
        bills: [],
        reservation: {},
        detail_payment: false,
			}
		},
		computed:{
      bill(){
        let data = {
          list: this.splitDataBill(),
          total: 0
        }
        for(let item of data.list){
          data.total += item.amount
        }
        return data
      },
      payment(){
        let data = {
          list: this.splitDataBill(true),
          total: 0
        }
        for(let item of data.list){
          data.total += item.amount
        }
        return data
      },
      balance(){
        return this.bill.total-this.payment.total
      },
			is_payment_valid(){
        let pm_checker = this.payment_methods.filter(x=> x.is_selected)
        return (pm_checker.length == 1) ? true : false
      },
      payment_surcharge(){
        let index_selected = this.payment_methods.findIndex(x=>x.is_selected)
        if(index_selected != -1){
          let pm_selected = this.payment_methods[index_selected].data
          if(pm_selected.surcharge_type == 'FIXED_AMOUNT'){
            return pm_selected.surcharge_value
          }else if(pm_selected.surcharge_type == 'PERCENT'){
            return (this.balance/100)*pm_selected.surcharge_value
          }else{
            return pm_selected.surcharge_value
          }
        }else{
          return 0
        }
      },
      total_bill(){
        return this.balance+this.payment_surcharge
      }
		},
    watch:{
      show_detail(){
        if(this.show_detail){
          document.getElementById('top_id').scrollIntoView({
            behavior: 'smooth'
          });
        }
      }
    },
		mounted(){
      this.loadGuestBill()
      this.loadReservation()
      this.getPaymentMethodList()
      // JOKUL
      let externalScript = document.createElement('script')
      externalScript.setAttribute('src', config.JOKUL_URL)
      document.head.appendChild(externalScript)
		},
		methods:{
			...mapGetters([
        'getMerchant',
        'getCurrentLanguage',
        'getConciergeAuth',
        'getMetaTitleTemplate'
      ]),
			formatCurrency(value){
        return formatCurrency(value);
      },
      formatDate(date){
        let data = moment(date,"YYYY-MM-DD")
        return formatDate(data);
      },
      togglePayment(index){
        for(let pm in this.payment_methods){
          this.payment_methods[pm].is_selected = false  
        }
        this.payment_methods_index = index
        this.payment_methods[index].is_selected = true
      },
      paymentMethodConverter(payment){
        return paymentMethodConverter(payment)
      },
      getPaymentMethodList(){
        return new Promise((done)=>{
          this.pm_loader = true
          this.error.payment_list = ''
          get("CONCIERGE","merchant-payment/"+this.getMerchant().id)
          .then(response=>{
            let res = response.data
            if (res.success) {
              for(let pm of res.data){
                let item = {
                  data: pm,
                  is_selected: false
                }
                this.payment_methods.push(item)
              }
            }else{
              this.error.payment_list = res.message
            }
            done()
            this.pm_loader = false
          })
        })
      },
      // method new
      loadGuestBill(){
        get("CONCIERGE",`reservation/${this.getConciergeAuth().detail_id}/${this.getConciergeAuth().folio}/guest-bill`,{
          merchant_id: this.getMerchant().id
        },'concierge_pin').then(response=>{
          let res = response.data
          if(res.success){
            this.bills = res.data
          }else{
            this.error.reservation = res.message
          }
        })
      },
      splitDataBill(is_payment=false){
        let data_default = this.bills.filter(x=>{
          if(is_payment){
            return x.type == 'PAYMENT'
          }else{
            return x.type != 'PAYMENT'
          }
        })
        let data_sorted_by_date = data_default.sort((a,b)=>a.created_at-b.created_at)
        return data_sorted_by_date
      },
      loadReservation(){
        this.is_load = true
        get("CONCIERGE",`reservation/${this.getConciergeAuth().detail_id}/${this.getConciergeAuth().folio}`,{
          merchant_id: this.getMerchant().id
          },'concierge_pin').then(response=>{
          let res = response.data
          if(res.success){
            this.reservation = res.data
          }else{
            this.error.reservation = res.message
          }
          this.is_load = false
        })
      },
      submitPaymentBill(){
        this.error.payment = ''
        let data = this.payment_methods[this.payment_methods_index].data
        let params = {
          merchant_id: this.getMerchant().id,
          reservation_id: this.reservation.id,
          amount: this.balance,
          payment_details: {
            id: data.id,
            payment_method: data.payment_method,
            bank_name: data.bank_name,
            payment_channel: data.payment_method
          }
        }
        this.payment_details = params.payment_details 
        this.push_loading.payment = true
        post("CONCIERGE", 'tx-guest-bill-payment', params, 'concierge_pin').then(response=>{
          let res = response.data
          if (res.success) {
            this.paymentMethodCheck(this.payment_details.bank_name, this.payment_details.payment_method, res)
          }else{
            this.error.payment = res.message
          }
          this.push_loading.payment = false
        })
      },
      paymentMethodCheck(bank_name, payment_method, res){
        if (bank_name == 'JOKUL_DOKU' && payment_method == 'CREDIT_CARD') {
          loadJokulCheckout(res.payment.url)
        }else if(bank_name == 'DOKU'){
          this.dkpayload.MALLID = res.payment.form.MALLID;
          this.dkpayload.BASKET = res.payment.form.BASKET;
          this.dkpayload.CHAINMERCHANT = res.payment.form.CHAINMERCHANT;
          this.dkpayload.AMOUNT = res.payment.form.AMOUNT;
          this.dkpayload.PURCHASEAMOUNT = res.payment.form.PURCHASEAMOUNT;
          this.dkpayload.TRANSIDMERCHANT = res.payment.form.TRANSIDMERCHANT;
          this.dkpayload.WORDS = res.payment.form.WORDS;
          this.dkpayload.REQUESTDATETIME = res.payment.form.REQUESTDATETIME;
          this.dkpayload.CURRENCY = res.payment.form.CURRENCY;
          this.dkpayload.PURCHASECURRENCY = res.payment.form.PURCHASECURRENCY;
          this.dkpayload.SESSIONID = res.payment.form.SESSIONID;
          this.dkpayload.PAYMENTCHANNEL = res.payment.form.PAYMENTCHANNEL;
          this.dkpayload.NAME = res.payment.form.NAME;
          this.dkpayload.EMAIL = res.payment.form.EMAIL;
          this.dkpayload.ADDRESS = res.payment.form.ADDRESS;
          this.dkpayload.MOBILEPHONE = res.payment.form.MOBILEPHONE;
          this.dkpayload.COUNTRY = res.payment.form.COUNTRY;
          this.dkpayload.URL = res.payment.payment_url;
          this.$nextTick(() => {
              this.$refs.FormDKload.submit();
          }); 
        }else if(bank_name == 'MIDTRANS'){
          let scriptTag = document.createElement('script');
          scriptTag.src = config.MIDTRANS_URL
          scriptTag.setAttribute('data-client-key', res.payment.client_key);
          document.head.appendChild(scriptTag);
          scriptTag.onload = function(){
            window.snap.pay(res.payment.token)
          }
        }else{
          this.$router.push({
            name: 'ConciergePaymentResult',
            params:{
              reservation_id: this.reservation.id,
              tx_payment_id : res.tx_order_id
            }
          })
        }
      }
		}
	}
</script>
<style scoped>
  .concierge-menu-top-wrapper{
    width:  70% !important;
  }

  .img-hotel{
    width: 60px;
    height: 60px;
  }

  @media screen and (min-width: 992px){
    .img-hotel{
      width: 50px;
      height: 50px;
    }
  }

  @media screen and (max-width: 768px){
    .concierge-menu-top-wrapper{
      width:  63% !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/hotel/concierge/ConciergeInquiry.vue